import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone } from 'lucide-react';
import { trackEvent } from '../api';

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <AnimatePresence>
      <motion.header
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-white/90 backdrop-blur-lg shadow-lg shadow-gray-200/50'
            : 'bg-transparent'
        }`}
      >
        <div className="container mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <h1
                className={`text-2xl font-bold transition-colors ${
                  scrolled
                    ? 'bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent'
                    : 'text-white'
                }`}
              >
                ADL Cleaning
              </h1>
            </motion.div>

            {/* Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              {[
                { label: 'Services', id: 'services' },
                { label: 'About', id: 'about' },
                { label: 'Reviews', id: 'reviews' },
              ].map((item) => (
                <motion.button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  className={`font-medium transition-colors ${
                    scrolled
                      ? 'text-gray-700 hover:text-teal-600'
                      : 'text-white/90 hover:text-white'
                  }`}
                >
                  {item.label}
                </motion.button>
              ))}
            </nav>

            {/* CTA Button */}
            <motion.a
              href="tel:0477502583"
              onClick={() => trackEvent('cta_click', 'header_call')}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              className={`flex items-center gap-2 px-6 py-3 rounded-full font-semibold transition-all ${
                scrolled
                  ? 'bg-gradient-to-r from-teal-600 to-cyan-600 text-white shadow-lg shadow-teal-200'
                  : 'bg-white text-teal-900 shadow-lg shadow-black/10'
              }`}
            >
              <Phone className="w-4 h-4" />
              <span className="hidden sm:inline">Call Now</span>
            </motion.a>
          </div>
        </div>
      </motion.header>
    </AnimatePresence>
  );
};
